import { render, staticRenderFns } from "./mdxx.vue?vue&type=template&id=3940c6b8&scoped=true&"
import script from "./mdxx.vue?vue&type=script&lang=js&"
export * from "./mdxx.vue?vue&type=script&lang=js&"
import style0 from "./mdxx.vue?vue&type=style&index=0&id=3940c6b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3940c6b8",
  null
  
)

export default component.exports